import { axios, isServer } from 'common/utils'
import { AnswerStatus } from 'common/constants/answerStatus'
import { Comments, CommentType } from 'common/types/entities/api/comment'
import { StateKey } from 'common/utils/flipState'
const FETCH = 'productQna/FETCH'

const initialQna: Comments = {
  contents: [],
  page: 0,
  size: 0,
  totalElements: 0,
  totalPages: 0,
  filterAnswerStatus: AnswerStatus.ALL,
  filterMyComment: false,
}

export const fetchQna = (
  curState: StateKey,
  type: CommentType,
  id: string,
  filter: AnswerStatus,
  filterMyComment: boolean,
  page: number,
  ctx?,
  pageSize?: number,
  stacked?: boolean,
) => async dispatch => {
  const headers = isServer &&
    ctx && {
      headers: {
        cookie: ctx.req.headers.cookie,
      },
    }
  const size = pageSize || 10

  const params = { filterMyComment, page, size }
  if (filter !== AnswerStatus.ALL) {
    params['sellerAnswerYn'] = filter === AnswerStatus.COMPLETED
  }

  const response = await axios.get<Comments>(`/v1/comments/${type}/${id}`, { headers, params })

  const qna = response ? response.data : initialQna
  if (qna) {
    qna.filterAnswerStatus = filter
    qna.filterMyComment = filterMyComment
    if (!qna.contents) qna.contents = []
  }

  dispatch({
    curState,
    qna,
    stacked,
    type: FETCH,
  })
}

// reducers
const productQnaReducer = (commentState = initialQna, action) => {
  switch (action.type) {
    case FETCH:
      if (action.stacked) {
        return {
          ...action.qna,
          contents: [...commentState.contents, ...action.qna.contents],
        }
      }
      return action.qna
    default:
      return commentState
  }
}

export default productQnaReducer
